import request from "@/api/request";
//订单明细/活动值明细
export const orderDetail = (param) => {
  return request(`/web-h5/charge/rankingActivity/orderDetail`, param, "POST");
};
